<template>
  <div class="tree-container">
    <!--摇钱树-->
    <div class="tree-wrap">
      <div class="img tree1" :style="{ backgroundImage: `url(${tree1Img})` }" />
      <div class="img tree2">
        <img
          v-show="!isLotterying"
          src="@/images/money_tree/tree/tree2_2021.gif"
        />
        <img
          v-show="isLotterying"
          src="@/images/money_tree/tree/tree2_down_2021.gif"
        />
      </div>
      <div class="img tree3">
        <!--抽奖按钮-->
        <div class="btn-wrap" @click="onStartLottery">
          <div class="btn">
            <img
              v-show="!isLotterying"
              src="@/images/money_tree/start_btn_2021.png"
              alt=""
            />
            <img
              v-show="isLotterying"
              src="@/images/money_tree/start_btn_2021.png"
              alt=""
            />
            <div class="times-wrap">
              剩余次数:&nbsp;&nbsp;
              <span class="times-num">{{ lotteryCount }}</span>
              &nbsp;&nbsp;次
            </div>
          </div>
        </div>
      </div>
      <div class="start-container">
        <!--规则-->
        <img
          src="@/images/money_tree/rule_2021.png"
          class="rule"
          @click="onGotoRule"
        />
        <!--中间的描述信息-->
        <div class="tips-content">
          <p>每日赠送一次机会</p>
          <p>下单满166赠送更多机会哦!</p>
        </div>
        <!--我的奖品-->
        <img
          src="@/images/money_tree/my_prize_2021.png"
          class="prize"
          @click="onShowMyRecords"
        />
      </div>
    </div>

    <!--弹幕-->
    <barrage :list="recentLotteryRecords" />
  </div>
</template>

<script>
import { API } from '@/api'
import { loginConfirm } from '@/utils/native_interactions/login'
import { DEPLOY_ENV } from '@/defines/env'
import win from './dialog/win'
import failWin from './dialog/failWin'
import records from './dialog/records'
import barrage from './barrage'
import { DialogAlert } from '@/utils/dialog.js'
import { tree1Img } from '@/defines/environment/config'

const moneyTreeRules = {
  test: 1001273,
  stage: 1001273,
  online: 1007653
}
export default {
  components: {
    barrage
  },
  data() {
    return {
      isLotterying: false, // 是否开始抽奖
      lotteryCount: 0, // 可抽奖次数
      recentLotteryRecords: [], // 本活动最近的获奖记录
      activityId: '',
      tree1Img
    }
  },
  async created() {
    this.activityId = this.$route.query.id
    try {
      await this.getLotteryCount()
      await this.getLotteryRecords()
    } catch (error) {
      this.$catch(error)
    }
  },
  methods: {
    /**
     * 活动规则
     */
    onGotoRule() {
      this.$track(this.$trackMap.moneyTree.gotoRule)
      if (!this.$root.isLogin) {
        loginConfirm()
        return
      }
      // h5Redirect(nativeRoutes.moneyTreeRules.h5, { transformMAppUrl: false })
      this.$router.push({ path: '/cms/' + moneyTreeRules[DEPLOY_ENV] })
    },

    /**
     * 开始抽奖
     */
    async onStartLottery() {
      if (this.isLotterying) {
        return this.$toast('请勿频繁点击抽奖')
      }
      this.$track(this.$trackMap.moneyTree.startLuck)
      if (!this.$root.isLogin) {
        loginConfirm()
        return
      }
      if (this.lotteryCount <= 0) {
        DialogAlert('老板，没有抽奖次数哦！')
        return
      }
      this.isLotterying = true
      setTimeout(() => {
        this.postLottery()
      }, 2000)
    },

    // 发送抽奖请求
    async postLottery() {
      let res
      try {
        res = await API.moneyTree.getLotteryLuck({
          lottery_activity_id: this.activityId
        })
      } catch (error) {
        this.isLotterying = false
        DialogAlert(error?.res?.error?.msg || '抽奖失败')
        this.getLotteryCount()
        return
      }

      this.isLotterying = false
      try {
        this.getLotteryCount()
      } catch (error) {}

      // 1 正常抽奖 返回status = 1
      // 2 当有0次的时候点击抽奖返回status=0(属于异常)
      // 3 当奖品抽完，抽奖返回status=3 奖品已经抽完
      const { status, prize } = res
      // 未中奖
      if (status !== 1) {
        this.showFailWin()
        return
      }
      // 正常抽奖(中奖或谢谢惠顾等也算中奖一种)
      this.$modal({
        component: win,
        clickMaskToClose: true,
        preventTouchmove: true,
        props: { prize } // 抽奖结果
      })
    },

    /**
     * 未中奖温馨提示
     */
    showFailWin() {
      this.$modal({
        component: failWin,
        clickMaskToClose: true,
        preventTouchmove: true,
        on: {
          click: () => {
            this.onStartLottery()
          }
        }
      })
    },

    /**
     * 我的奖品记录
     */
    onShowMyRecords() {
      this.$track(this.$trackMap.moneyTree.myRecords)
      if (!this.$root.isLogin) {
        loginConfirm()
        return
      }
      this.getMyLotteryRecords()
    },

    /**
     * 根据活动ID获取用户剩余抽奖次数
     */
    async getLotteryCount() {
      const res = await API.moneyTree.getLotteryCount({
        lottery_activity_id: this.activityId
      })
      this.lotteryCount = res.draw_count
    },

    /**
     * 获取本次活动最近中奖记录
     */
    async getLotteryRecords() {
      try {
        const res = await API.moneyTree.getLotteryRecords({
          lottery_activity_id: this.activityId
        })
        this.recentLotteryRecords = res.recordList || []
      } catch (error) {}
    },

    /**
     * 获取我的获奖记录
     */
    getMyLotteryRecords() {
      clearTimeout(this.recordTimer)
      this.recordTimer = setTimeout(async () => {
        try {
          const res = await API.moneyTree.getMyLotteryRecords({
            lottery_activity_id: this.activityId
          })
          const recordList = res.myRecordList || []
          this.$modal({
            component: records,
            clickMaskToClose: true,
            preventTouchmove: true,
            props: { recordList }
          })
        } catch (error) {
          this.$toast('获取数据失败')
        }
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-container {
  position: relative;

  .btn-wrap {
    display: flex;

    margin-top: -0.06rem;
    margin-right: 0.12rem;

    justify-content: center;
    .tip-wrap {
      height: 0.44rem;

      text-align: center;
      .tip {
        padding: 0.14rem;

        background: rgba(255, 255, 255, 0.8);

        font-size: 0.22rem;
        text-align: center;
        color: #0b7c23;
        border-top-left-radius: 0.16rem;
        border-top-right-radius: 0.16rem;
      }
    }

    .btn {
      position: relative;
      top: 0.82rem;

      width: 3.88rem;
      height: 1.24rem;
      overflow: hidden;
      img {
        position: absolute;

        width: 100%;
        height: 100%;
      }
      .times-wrap {
        position: absolute;
        bottom: 0.2rem;
        left: 1.15rem;
        z-index: 10;

        font-size: 0.24rem;
        color: #ffffff;
        box-shadow: 0px 3px 7px 0px #e12e3f;
        .times-num {
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
    }
  }

  .tree-wrap {
    display: flex;

    flex-direction: column;

    .img {
      width: 100%;

      margin: 0;
      padding: 0;

      overflow: hidden;
      background-size: 100% 100%;

      background-repeat: no-repeat;

      &.tree1 {
        height: 4.08rem;
      }
      &.tree2 {
        height: 5.74rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &.tree3 {
        height: 2.05rem;

        background-image: url('../../../images/money_tree/tree/tree3_2021.gif');
      }
    }
  }

  .start-container {
    display: flex;

    position: absolute;
    top: 9.1rem;

    width: 100%;

    margin-top: 0.09rem;

    padding: 0 0.2rem;

    justify-content: space-between;
    align-items: center;
  }

  .tips-content {
    display: flex;

    width: 3.1rem;
    height: 0.74rem;
    margin: 0 0.09rem;
    margin-top: 0.45rem;

    background-color: rgba($color: #68ae23, $alpha: 0.7);
    border-radius: 0.36666rem;

    flex-direction: column;

    justify-content: center;

    font-size: 0.22rem;
    text-align: center;
    color: #ffffff;
  }

  .rule {
    width: 1.37rem;
    height: 1.48rem;
  }

  .prize {
    width: 1.37rem;
    height: 1.48rem;
  }
}
</style>
